import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Read Vietnamese, pick the English translation. */
export function VietnameseToEnglish({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  return (
    <>
      <ChallengeShell tag="Translate" prompt={`What is "${word.vietnamese}" in English?`}>
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.english}</span>}
        />
      </ChallengeShell>
      {teachOverlay}
    </>
  );
}
